import router from "./index";

export default [{
  path: "/select",
  component: () => import('../views/Select/Select'),
  beforeEnter: (to, from, next) => {
    if (router.app.$cookies.get("user") === "student")
      next();
    else
      router.replace("/home");
  },
  meta: {
    title: '选课'
  },
  children: [
    {
      path: '/',
      redirect: 'selectlist'
    },
    {
      path: 'selectlist',
      component: () => import('../views/Select/SelectList/SelectList'),
      meta: {
        title: '选课列表'
      },
    },

  ]
},]
